"use client";

import BaseSlider, {
  SliderSlide as BaseSliderSlide,
  SliderProps
} from "@silversea-ssc/system-components-react/Slider";

export type ClientSliderProps = SliderProps;

const ClientSlider: React.FC<React.PropsWithChildren<ClientSliderProps>> = ({
  children,
  ...props
}) => {
  //   const onSlideChange = useCallback((slideNumber: number) => {
  //     dispatchTrackingEvent("slider_slide_changed", {
  //       value: slideNumber
  //     });
  //   }, []);

  return (
    <BaseSlider
      {...props}
      //onSlideChange={onSlideChange}
    >
      {children}
    </BaseSlider>
  );
};

const SliderSlide = BaseSliderSlide;
export { SliderSlide };
export default ClientSlider;
